import request from "./axios";

/**
 * 微信登录二维码参数
 */
export function getQrcodeLoginParam(redirect){
    return request({
        url: "/api/wechatAuth/getQrcodeLoginParam?redirectUrl=" + redirect,
        method: "get"
    })
}




// WEBPACK FOOTER //
// ./src/api/wechat.js